import Select from "react-select";
import { useQuery } from "@tanstack/react-query";
import { replaceUnderscoresWithSpaces } from "utils";
import { fetchInvestigationTemplate } from "services/dropdown";
import { useEffect, useState } from "react";

const TemplateDropDown = ({ investigationId, setFilterValue, template }) => {
  const key = "template";
  const [selectedOption, setSelectedOption] = useState(null);

  const { data, isLoading, error } = useQuery(
    ["investigation-template-dropdown", investigationId],
    () => fetchInvestigationTemplate({ investigation_id: investigationId }),
    {
      keepPreviousData: false,
      staleTime: 0,
    }
  );

  useEffect(() => {
    if (!data?.data || data.data.length === 0) return;

    if (template && template.template_id) {
      const matchingTemplate = data.data.find(
        (item) => item.id === template.template_id
      );
      if (matchingTemplate) {
        setSelectedOption({
          value: matchingTemplate.id,
          label: matchingTemplate.template,
          template_description: matchingTemplate.template_description,
        });
        return;
      }
    }

    const defaultTemplate = data.data.find(
      (item) => item.is_default_template === true
    );
    if (defaultTemplate) {
      setSelectedOption({
        value: defaultTemplate.id,
        label: defaultTemplate.template,
        template_description: defaultTemplate.template_description,
      });
      setFilterValue({
        template_id: defaultTemplate.id,
        template: defaultTemplate.template,
        template_description: defaultTemplate.template_description,
      });
    }
  }, [data, setFilterValue, template]);

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error loading comment names</div>;

  const options =
    data?.data?.map((item) => ({
      value: item.id,
      label: item.template,
      template_description: item?.template_description,
    })) || [];

  return (
    <Select
      options={options}
      isClearable
      placeholder={`Select ${replaceUnderscoresWithSpaces(key)}`}
      menuPortalTarget={document.body}
      styles={{
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
      }}
      value={selectedOption}
      onChange={(selectedOption) => {
        setSelectedOption(selectedOption);
        const value = selectedOption ? selectedOption.value : "";
        const label = selectedOption ? selectedOption.label : "";
        const template_description = selectedOption
          ? selectedOption.template_description
          : "";
        setFilterValue({
          template_id: value,
          template: label,
          template_description: template_description,
        });
      }}
      className={`react-select-container is-invalid`}
    />
  );
};

export default TemplateDropDown;
